import useAppState from './useAppState';

const useAccessToken = (): string => useAppState().accessToken;

export default useAccessToken;
